import { Box, Stack } from '@mui/material';
import { memo } from 'react';

//
import type { NavListProps, NavSectionProps } from '../types';

import NavList from './NavList';

const NavSectionMini = ({ data, sx, ...other }: NavSectionProps) => {
  return (
    <Stack
      alignItems="center"
      spacing={0.5}
      sx={{
        px: 0.75,
        ...sx,
      }}
      {...other}
    >
      {data.map((group, index) => (
        <Items
          isLastGroup={index + 1 === data.length}
          items={group.items}
          key={group.subheader}
        />
      ))}
    </Stack>
  );
};

export default memo(NavSectionMini);

// ----------------------------------------------------------------------

type ItemsProps = {
  isLastGroup: boolean;
  items: NavListProps[];
};

const Items = ({ isLastGroup, items }: ItemsProps) => {
  return (
    <>
      {items.map((list) => (
        <NavList
          data={list}
          depth={1}
          hasChild={!!list.children}
          key={list.title + list.path}
        />
      ))}

      {!isLastGroup && (
        <Box
          sx={{
            bgcolor: 'divider',
            height: '1px',
            my: '8px !important',
            width: 24,
          }}
        />
      )}
    </>
  );
};
